import {TripSessionCache} from "@/infrastructure/storage";

const RESERVATION_ID_KEY = "reservationId";

export function saveTripSession(reservationId: string): void {
    TripSessionCache().set(RESERVATION_ID_KEY, reservationId);
}

export function getTripSessionReservationId(): string | null {
    return TripSessionCache().get<string>(RESERVATION_ID_KEY);
}

export function clearTripSession(): void {
    TripSessionCache().remove(RESERVATION_ID_KEY);
}
